import { AiAssistantRowActions } from 'modules/cms/seo/ai-assistant/components/AiAssistantRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { IAiAssistant } from 'modules/cms/seo/ai-assistant/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { AI_ASSISTANT_PERMISSIONS } from 'modules/cms/seo/ai-assistant/constants/ai-assistant.permissions';

export const aiAssistantNameColumn: HeadCell<IAiAssistant> = {
  field: 'name',
  headerName: 'aiAssistant:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IAiAssistant) => <EditLink entityId={data?._id as string}>{name}</EditLink>,
};

export const aiAssistantDescriptionColumn: HeadCell<IAiAssistant> = {
  field: 'description',
  headerName: 'aiAssistant:fields.description',
};

export const aiAssistantActionsColumn: HeadCell<IAiAssistant> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: AI_ASSISTANT_PERMISSIONS.AI_ASSISTANT_CONFIG,
  headerName: 'common:actions',
  disablePadding: true,
  component: AiAssistantRowActions,
};

export const aiAssistantColumns: Array<HeadCell<any>> = [
  aiAssistantNameColumn,
  aiAssistantDescriptionColumn,
  createdATColumn,
  aiAssistantActionsColumn,
];
